import { gotoChat, meetingCountStatus, toastInformation } from "./callService/common";
import iconImg from "../../src/styles/images/worktual.jpg";
import { closeVideoRinging } from "./utils";
import { LoginState } from "../models/model";
import store from "../context/store/store";
import { updateMeetingRead } from "./meetingService/apiService";


function notificationData(inputOptions: any, list?: any) {
  let { historySet }: LoginState = store.getState().loginReducer;
  var imgUrl = inputOptions?.id && inputOptions?.id?.ImageURL ? inputOptions?.id?.ImageURL : ''
 // let options = { body: (list?.message?.teamAction?.actionKey ===  "add_member" || list?.message?.teamAction?.actionKey === "remove_member"
  // || list?.message?.teamAction?.actionKey === "make_admin"  || list?.message?.teamAction?.actionKey === "make_member" || list?.message?.teamAction?.actionKey === "update_group" ||list?.message?.teamAction?.actionKey === "leave_member" )  ?  ""  :inputOptions?.message.replace(/(<([^>]+)>)|&nbsp;/gi, " "), icon: imgUrl};

  let options = { body: inputOptions.message.replace(/(<([^>]+)>)|&nbsp;/gi, " "), icon: imgUrl};
  var notification = new Notification((inputOptions?.GroupId?.team_id ? inputOptions?.userName + `\n${inputOptions?.titleFetch}`: inputOptions?.userName +" "+ inputOptions?.titleFetch), options);
  // var notification = new Notification((inputOptions?.GroupId?.team_id  || inputOptions?.isLiked ?  (inputOptions?.userName === "" &&  list?.message?.teamAction?.actionKey === "leave_member" )  ? inputOptions?.message +`\n${inputOptions?.titleFetch}` :  inputOptions?.userName +`\n${inputOptions?.titleFetch}`:  inputOptions?.userName+inputOptions?.titleFetch), options);
  notification.onclick = function (event) {
    event.preventDefault();
    window.parent.focus();
    historySet.push('/chats');
    // if(window.location.pathname !== '/chats' && inputOptions?.type === 'chat'){
    //   window.location.href = '/chats';
    // }
    inputOptions?.GroupId ? gotoChat(inputOptions?.GroupId, "", list) : gotoChat(inputOptions?.id, "", list);
    notification.close();

  };
}

function notificationBrowserData(inputOptions: any, page: any) {
  var title = `${inputOptions.userName}`;
  var text = inputOptions.message;
  var url = inputOptions.url;
  let options = { body: text, icon: iconImg };
  var notificationBrowser = new Notification(title, options);
  notificationBrowser.onclick = function (event) {
    event.preventDefault();
    window.parent.focus();
    if (page !== 'enablenoti') {
      window.open(url, "_blank");
    }
    if (page === "meeting") {
      console.log("meeting+++++");
      let uuid:any =url.substring(url.lastIndexOf("/")+1).toString();
          meetingCountStatus(true);
         updateMeetingRead(uuid);
      closeVideoRinging();
    }
    //gotoChat(inputOptions?.id,"");
    notificationBrowser.close();
  };
}

function showNotification(inputOptions: any, list?: any) {
  if (!("Notification" in window)) {
    alert("This browser does not support desktop notification");
  }

  else if (Notification.permission === "granted") {
    window.location.pathname !== '/login' && window.location.pathname !== '/' && notificationData(inputOptions, list);
  }
  else if (Notification.permission !== "denied") {
    Notification.requestPermission().then(function (permission) {
      if (permission === "granted") {
        window.location.pathname !== '/login' && window.location.pathname !== '/' && notificationData(inputOptions, list);
      } else {
        toastInformation('Please manually enable permission', 'success')
      }
    });
  }
}

function showBrowserNotification(inputOptions: any, page: any) {
  if (!("Notification" in window)) {
    alert("This browser does not support desktop notification");
  }

  else if (Notification.permission === "granted") {
   
    window.location.pathname !== '/login' && window.location.pathname !== '/' && notificationBrowserData(inputOptions, page);
  }
  else if (Notification.permission !== "denied") {
    
    Notification.requestPermission().then(function (permission) {
      if (permission === "granted") {
        
        window.location.pathname !== '/login' && window.location.pathname !== '/' && notificationBrowserData(inputOptions, page);
      } else {
        toastInformation('Please manually enable permission', 'success')
      }
    });
  }
}

export {
  showNotification,
  showBrowserNotification
};


